import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";

const trainersBaseController = "api/trainers";


export const paGetAllTrainers = async (body = {}) => {
  let urlParams = generalFunc.generateUrlParams(body)
  console.log(body, urlParams)

  try {
    if (navigator.onLine) {
      const response = await api.get(`${trainersBaseController}/get-all-trainers${urlParams}`)
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export const paGetTrainerById = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.get(`${trainersBaseController}/get-trainer-by-id?skillCenterId=${body}`)
      return response.data.data;
    }
  } catch (error) {
    throw error;
  }
}

export const physicalVerification = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${trainersBaseController}/physical-verification`, body)
      toastr.success("Success", response.data.message)
      return response.data;
    }
  } catch (error) {
    if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST') {
      toastr.error("Ooops, an error occurred", "and it's not your fault, please try again shortly!");
    } else {
      toastr.error("We encountered an error processing that request", "Please try again shortly")
    }
    throw error;
  }
}